import * as React from 'react';

import DashboardIcon from '@mui/icons-material/Dashboard';
import ItemMenu from '../../components/ItemMenu';
import { Divider, List } from '@mui/material';
import { AccountTree, BarChart, Group, Hub, LanOutlined, Person, Subscriptions, VerifiedUser } from '@mui/icons-material';
import { useAuth } from '../../components/AuthProvider';
import Config from './Config';
import Profile from '../profile';

export const Menu = ({ open }) => {
  const auth = useAuth();
  return (
    <List>
      <ItemMenu icon={<DashboardIcon />} name="Dashboard" path="/" />
      <ItemMenu icon={<LanOutlined />} name="Hosts" path="/host" />
      <ItemMenu icon={<BarChart />} name="Relatório de Erros" path="/error-backup" />
      <ItemMenu icon={<Subscriptions />} name="Fila" path="/queue" />
      <ItemMenu icon={<Hub />} name="Conectividade" path="/tunnel" perm="tunnel.get_all" />
      <ItemMenu icon={<AccountTree />} name="(BETA) Inventário" path="/inventory" perm="inventory.get_all" />
      <Divider />
      <ItemMenu icon={<BarChart />} name="Log Auditoria" path="/audit" />
      <ItemMenu icon={<Group />} name="Cargos" path="/role" perm="role.get_all" />
      <ItemMenu icon={<Person />} name="Usuários" path="/user" perm="user.get_all" />
      <Divider />
      <ItemMenu icon={<VerifiedUser />} name="Licença" path="/license-detail" />
      <Profile />
      <Config />
    </List>
  );
};

export const secondaryListItems = (
  <React.Fragment></React.Fragment>
);
